module.exports = __webpack_public_path__ + "img/triangle.6d6ef7c9.svg";